import { BaseState } from '@/store/base-state';
import { TableOptions, PaginationProps } from '@/types';
import {
  default_new_offer_template,
  default_new_offer,
  default_catalog_products_filters,
} from '../services';
import {
  CommercialOffer,
  CommercialOfferTemplate,
  OfferTemplatesFilters,
  OrganizationForFilters,
  NewCommercialOfferTemplate,
  NewCommercialOffer,
  CommercialOfferFilters,
  CommercialOffers,
} from '../types';

export default class CommercialOffersState extends BaseState {
  commercial_offers: CommercialOffer[] = []

  new_offer = default_new_offer();

  new_offer_template = default_new_offer_template();

  current_offer: NewCommercialOffer = default_new_offer();

  current_offer_template: NewCommercialOfferTemplate = default_new_offer_template();

  offers_templates: CommercialOfferTemplate[] = []

  organizations_for_filters: OrganizationForFilters[] = [];

  clients_for_filters: string[] = [];

  offers_loading = false;

  offer_templates_loading = false;

  logos_to_remove: number[] = [];

  active_tab = 0;

  has_template = false;

  catalog_products_loading = false;

  catalog_products: CommercialOffers.CatalogProduct[] = [];

  catalog_products_filters: CommercialOffers.CatalogProductRequestFilters = default_catalog_products_filters();

  filters: OfferTemplatesFilters = {
    search: '',
    dates: [],
    organizations: [],
  };

  offers_filters: CommercialOfferFilters = {
    search: '',
    dates: [],
    clients: [],
  };

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['created_at'],
    sortDesc: [true],
  };

  pagination_offers_list: PaginationProps = {
    current_page: 1,
    total_pages: 1,
    total_items: 0,
    limit: 10,
  };

  table_options_offers_list: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['created_at'],
    sortDesc: [true],
  }

  catalog_products_pagination_props: PaginationProps = {
    current_page: 1,
    total_pages: 1,
    total_items: 0,
    limit: 10,
  };

  catalog_products_table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['created_at'],
    sortDesc: [true],
  }
}
